import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import PageLayout from '../../components/Layout/PageLayout/PageLayout';
import Loader from '../../components/Loader/Loader';
import Popup from '../../components/Popup/Popup';
import PrivacyPolicy from '../../components/PravicyPolicy/PrivacyPolicy';
import SidebarDetails from '../../components/SidebarDetails/SidebarDetails';
import TermOfUse from '../../components/TermOfUse/TermOfUse';
import { useLocale } from '../../context/LocaleContext';
import GuestInformationForm from './components/GuestInformationForm/GuestInformationForm';
import PaymentCard from './components/PaymentCard/PaymentCard';
import Total from './components/Total/Total';
import usePaymentPage from './hooks/usePaymentPage';
import { PageTitleStyled } from './PaymentDetailsPage.styled';

const PaymentDetailsPage: React.FC = () => {
  const { selectedLocale } = useLocale();
  const { isLoading, sustainableActions, carbonOffsets, handleClickBack } = usePaymentPage();
  const [isTermsAndConditionModalShown, setTermsAndConditionModalShown] = useState(false);
  const [isPrivacyPolicyModalShown, setPrivacyPolicyModalShown] = useState(false);
  const [isReloadStripeInstance, setReloadStripeInstance] = useState(false);
  const [isBreadcrumbClicked, setIsBreadcrumbClicked] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isPaymentCardShow, setIsPaymentCardShow] = useState(false);

  useEffect(() => {
    setReloadStripeInstance(true);

    setTimeout(() => setReloadStripeInstance(false), 300);
  }, [selectedLocale]);

  return (
    <>
      <PageLayout
        isLoading={isLoading}
        onClickBreadcrumb={() => {
          setIsBreadcrumbClicked(prev => prev + 1);
        }}
        onClickBack={handleClickBack}
        backButtonLabel={
          !!sustainableActions.length ? (
            <FormattedMessage id="button.backToSA" defaultMessage="Back to Sustainable Actions" />
          ) : (
            <FormattedMessage id="button.backToCO" defaultMessage="Back to Carbon Offset" />
          )
        }
        topSectionContent={
          <PageTitleStyled level={2}>
            <FormattedMessage
              id="sustainableActions.purchaseDetails.title"
              defaultMessage="Purchase Details"
            />
          </PageTitleStyled>
        }
        leftSideContent={
          <>
            <GuestInformationForm isFieldsDisabled={isPaymentCardShow}>
              {isPaymentCardShow ? (
                isReloadStripeInstance ? (
                  <Loader />
                ) : (
                  <PaymentCard
                    isBreadcrumbClicked={isBreadcrumbClicked}
                    sustainableActions={sustainableActions}
                    carbonOffsets={carbonOffsets}
                  />
                )
              ) : (
                <Total
                  total={totalAmount}
                  showSAText={!!sustainableActions.length}
                  onClickPrivacyPolicy={() => setPrivacyPolicyModalShown(true)}
                  onClickTermsAndCondition={() => setTermsAndConditionModalShown(true)}
                  onClickNext={() => setIsPaymentCardShow(true)}
                />
              )}
            </GuestInformationForm>
          </>
        }
        rightSideContent={
          <SidebarDetails
            isPurchaseButtonHidden
            isEmptyCartShown={false}
            selectedSustainableActions={sustainableActions}
            selectedCarbonOffsetProjects={carbonOffsets}
            onChangeTotal={setTotalAmount}
          />
        }
      />

      <Popup
        isBackButton={isTermsAndConditionModalShown && isPrivacyPolicyModalShown}
        onClickBack={() => setPrivacyPolicyModalShown(false)}
        isOpen={isTermsAndConditionModalShown || isPrivacyPolicyModalShown}
        onClose={() => {
          setTermsAndConditionModalShown(false);
          setPrivacyPolicyModalShown(false);
        }}
      >
        {(isTermsAndConditionModalShown && isPrivacyPolicyModalShown) ||
        isPrivacyPolicyModalShown ? (
          <PrivacyPolicy />
        ) : (
          <TermOfUse onClickPrivacyPolicy={() => setPrivacyPolicyModalShown(true)} />
        )}
      </Popup>
    </>
  );
};

export default PaymentDetailsPage;
